import React from 'react';
import { useNavigate } from 'react-router-dom';
import colors from '../../theme/colors';
import CommonButton from '../../components/common/CommonButton';

const PageNotFound = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    const token = localStorage.getItem('token');
    navigate(token ? '/dashboard' : '/login', { replace: true });
  };

  return (
    <>
      <style>{`
        @keyframes floatY {
          0%, 100% { transform: translateY(0px); }
          50%       { transform: translateY(-12px); }
        }
        @keyframes blobDrift {
          0%, 100% { transform: translate(0, 0) scale(1); }
          33%       { transform: translate(30px, -20px) scale(1.05); }
          66%       { transform: translate(-20px, 15px) scale(0.97); }
        }
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(24px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .pnf-fade1 { animation: fadeInUp 0.6s ease both; }
        .pnf-fade2 { animation: fadeInUp 0.6s 0.15s ease both; }
        .pnf-fade3 { animation: fadeInUp 0.6s 0.3s ease both; }
        .pnf-fade4 { animation: fadeInUp 0.6s 0.45s ease both; }
      `}</style>

      <div style={{
        minHeight: '100vh',
        width: '100%',
        background: 'var(--bg-splash)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px 16px',
        boxSizing: 'border-box',
        position: 'relative',
        overflow: 'hidden',
      }}>

        {/* Background blobs */}
        <div style={{
          position: 'absolute', top: '-80px', right: '-80px',
          width: 320, height: 320, borderRadius: '50%',
          background: 'var(--blob-primary)',
          animation: 'blobDrift 8s ease-in-out infinite',
          pointerEvents: 'none',
        }} />
        <div style={{
          position: 'absolute', bottom: '-60px', left: '-60px',
          width: 280, height: 280, borderRadius: '50%',
          background: 'var(--blob-secondary)',
          animation: 'blobDrift 10s 2s ease-in-out infinite',
          pointerEvents: 'none',
        }} />
        <div style={{
          position: 'absolute', top: '40%', left: '5%',
          width: 160, height: 160, borderRadius: '50%',
          background: 'var(--blob-primary-sm)',
          animation: 'blobDrift 12s 1s ease-in-out infinite',
          pointerEvents: 'none',
        }} />

        {/* Card */}
        <div style={{
          maxWidth: 520,
          width: '100%',
          background: 'var(--bg-glass)',
          backdropFilter: 'blur(16px)',
          WebkitBackdropFilter: 'blur(16px)',
          borderRadius: 20,
          padding: '48px 40px 40px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          boxSizing: 'border-box',
        }}>

          {/* Illustration */}
          <div className="pnf-fade1" style={{ marginBottom: 24 }}>
            <img
              src="/assets/images/404_error.svg"
              alt="Page Not Found"
              style={{
                width: '100%',
                maxWidth: 320,
                height: 'auto',
                maxHeight: '38vh',
                objectFit: 'contain',
                pointerEvents: 'none',
                mixBlendMode: 'multiply',
                animation: 'floatY 3.5s ease-in-out infinite',
              }}
            />
          </div>

          {/* Badge */}
          <div className="pnf-fade2" style={{
            display: 'inline-flex', alignItems: 'center', gap: 6,
            background: 'var(--bg-badge-brand)',
            border: '1px solid var(--border-badge-brand)',
            borderRadius: 99,
            padding: '5px 14px',
            marginBottom: 20,
          }}>
            <span style={{
              fontFamily: 'PlusJakartaSans-SemiBold, sans-serif',
              fontSize: 12,
              background: `linear-gradient(90deg, ${colors.themeColor}, ${colors.blueColor})`,
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              letterSpacing: 0.4,
            }}>
              404 — PAGE NOT FOUND
            </span>
          </div>

          {/* Title */}
          <h1 className="pnf-fade2" style={{
            fontFamily: 'PlusJakartaSans-SemiBold, sans-serif',
            fontSize: 26,
            margin: '0 0 12px',
            background: `linear-gradient(90deg, ${colors.mainColor}, ${colors.themeColor})`,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            lineHeight: 1.3,
          }}>
            Oops! Page Not Found
          </h1>

          {/* Description */}
          <p className="pnf-fade3" style={{
            fontFamily: 'PlusJakartaSans-Regular, sans-serif',
            fontSize: 15,
            color: colors.subTextColor,
            lineHeight: 1.7,
            margin: '0 0 28px',
            maxWidth: 380,
          }}>
            The page you're looking for doesn't exist or has been moved.
            Let's get you back on track!
          </p>

          {/* Buttons */}
          <div className="pnf-fade4" style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 10 }}>
            <CommonButton
              title="Go to Home"
              icon="solar:home-bold"
              iconPosition="left"
              onClick={handleGoHome}
              width="100%"
              height={48}
              style={{ margin: 0, borderRadius: 14 }}
            />
            <CommonButton
              title="Go Back"
              icon="solar:arrow-left-bold"
              iconPosition="left"
              onClick={() => navigate(-1)}
              variant="outline"
              width="100%"
              height={48}
              style={{ margin: 0, borderRadius: 14 }}
            />
          </div>

        </div>
      </div>
    </>
  );
};

export default PageNotFound;
